import { IScannable } from './scannable.interface';

export class Scannable implements IScannable {
  constructor(
    public readonly payload: string,
    public readonly type: string
  ) {}

  public static hydrate(obj: IScannable): IScannable {
    return new Scannable(obj.payload, obj.type);
  }
}
